import React from 'react'
import PropTypes from 'prop-types'

import { matchPlanMeta } from '../../utils/plans'
import plansMeta from '../../constants/plans'
import PlanCardSmall from '../PlanCardSmall'
import { PlansWrapper } from './styles'

const PLAN_CARDS_GROUP_DISCOUNT = ['1gb-data', '2gb-data', '3gb-data']

const DataDiscountPlans = ({
  currentPlan,
  plans,
  hideProductAttributes = false,
}) => (
  <section id="data-discount-plans">
    <PlansWrapper>
      {PLAN_CARDS_GROUP_DISCOUNT.map((p, index) => {
        const isCurrentPlan = currentPlan && p === currentPlan.slug
        const { priceData, planMeta } = matchPlanMeta(plans, p, plansMeta)
        return (
          <PlanCardSmall
            key={p}
            index={index}
            to={isCurrentPlan ? null : `/plans/${p}`}
            href={isCurrentPlan ? `/order/${p}` : null}
            planMeta={planMeta}
            priceData={priceData}
            // position is a data layer modules prop item
            // indicates the position of PlanCardSmall in the modules array
            position={index + 1}
            eventName={null}
            cta={isCurrentPlan ? 'Get' : 'View'}
            hideProductAttributes={hideProductAttributes}
            isDiscountPlan
          />
        )
      })}
    </PlansWrapper>
  </section>
)

DataDiscountPlans.propTypes = {
  currentPlan: PropTypes.object,
  plans: PropTypes.array,
  hideProductAttributes: PropTypes.bool,
}

export default DataDiscountPlans
